import { render, staticRenderFns } from "./HelpIcon.vue?vue&type=template&id=6c8b1644&scoped=true&lang=pug"
import script from "./HelpIcon.vue?vue&type=script&lang=ts"
export * from "./HelpIcon.vue?vue&type=script&lang=ts"
import style0 from "./HelpIcon.vue?vue&type=style&index=0&id=6c8b1644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8b1644",
  null
  
)

export default component.exports